import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from "@angular/router";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private snackBar: MatSnackBar, private router: Router) {}

  intercept(req: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    let modifiedRequest;
    if (req.url.includes('auth/login') || 
      req.url.includes('auth/send-email-validacao') || 
      req.url.includes('auth/create-update-user') || 
      req.url.includes('storage.googleapis.com')) {
      modifiedRequest = req
    } else {
      const token = sessionStorage.getItem('token');
      modifiedRequest = req.clone({
        setHeaders: {
          'Authorization': `Bearer ${token}`
        }
      });
    }
    return handler.handle(modifiedRequest).pipe(
        catchError((error: HttpErrorResponse) => {

          if (error.status === 401) {
            console.error('Unauthorized request:', error);
            this.snackBar.open(error.error.message, 'Fechar', {
              duration: 3000,
              panelClass: ['error-snackbar']
            });
            sessionStorage.removeItem('token');
            this.router.navigate(['/login']);   
            // Redirect to login page or perform any other action
          } else if (error.status === 403) {
            console.error('Forbidden request:', error);
            this.snackBar.open(error.error.message, 'Fechar', {
              duration: 3000,
              panelClass: ['error-snackbar']
            });
            sessionStorage.removeItem('token');
            this.router.navigate(['/login']);
          } else {
            if (error.error instanceof ErrorEvent) {
              console.error('Client-side error:', error.error.message);
              this.snackBar.open(JSON.stringify(error.error.message), 'Fechar', {
                duration: 3000,
                panelClass: ['error-snackbar']
              });
            } else {
              console.error('Server-side error:', error);
              this.snackBar.open(JSON.stringify(error.error.message), 'Fechar', {
                duration: 3000, 
                panelClass: ['error-snackbar'], 
              });
            }
          }
          return throwError(() => error);
        })
      );
  }
}